// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"99621a77","478":"6ab8ed14","1335":"54b9975b","2195":"54b9975b","2859":"024369a4","5698":"54b9975b","6435":"01ce1222","7362":"24de83e2","8042":"fede262b","9623":"99621a77"}[chunkId] + ".chunk.css";
};